import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useTransactionStore = defineStore('transactions', {
  state: () => ({
    transactions: [],
    categoryData: [],
    loading: false,
    error: null,
  }),
  actions: {
    async fetchTransactions(startDate, endDate) {
      this.loading = true;
      try {
        const params = new URLSearchParams();
        if (startDate) params.append('start_date', startDate);
        if (endDate) params.append('end_date', endDate);
        const response = await authFetch(`${API_URL}/transactions/?${params}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        this.transactions = await response.json();
      } catch (error) {
        this.error = error;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async addTransaction(transaction) {
      try {
        const payload = {
          ...transaction,
          date: transaction.date ? new Date(transaction.date).toISOString().split('T')[0] : null,
        };
        const response = await authFetch(`${API_URL}/transactions/`, {
          method: 'POST',
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const created = await response.json();
        this.transactions.unshift(created);
        return created;
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async updateTransaction(transactionId, transaction) {
      try {
        const payload = {
          ...transaction,
          date: transaction.date ? new Date(transaction.date).toISOString().split('T')[0] : null,
        };
        const response = await authFetch(`${API_URL}/transactions/${transactionId}`, {
          method: 'PATCH',
          body: JSON.stringify(payload),
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const updated = await response.json();
        const index = this.transactions.findIndex(t => t.id === transactionId);
        if (index !== -1) this.transactions[index] = updated;
        return updated;
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async deleteTransaction(transactionId) {
      try {
        const response = await authFetch(`${API_URL}/transactions/${transactionId}`, {
          method: 'DELETE',
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        this.transactions = this.transactions.filter(t => t.id !== transactionId);
      } catch (error) {
        this.error = error;
        throw error;
      }
    },

    async previewInvoice(formData) {
      // Must use raw fetch — authFetch forces Content-Type:application/json
      // which breaks multipart/form-data boundary
      const response = await fetch(`${API_URL}/invoices/import`, {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      if (response.status === 401) {
        window.location.href = '/login';
        throw new Error('Session expired');
      }
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.detail || `Erreur ${response.status}`);
      }
      return response.json();
    },

    async fetchCategoryData(startDate, endDate) {
      try {
        const params = new URLSearchParams();
        if (startDate) params.append('start_date', startDate);
        if (endDate) params.append('end_date', endDate);
        const response = await authFetch(`${API_URL}/charts/transactions-by-category/?${params}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        this.categoryData = await response.json();
      } catch (error) {
        this.error = error;
        throw error;
      }
    },
  },
});
